// extracted by mini-css-extract-plugin
export default {"inputRow":"DialogVersionDuplicateSome__inputRow--rlg73ix","versionTitleInput":"DialogVersionDuplicateSome__versionTitleInput--i4I2HC0"};